var ApplicationInfoDto = /** @class */ (function () {
    function ApplicationInfoDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) {
                    this[property] = data[property];
                }
            }
        }
    }
    ApplicationInfoDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ApplicationInfoDto();
        result.init(data);
        return result;
    };
    ApplicationInfoDto.prototype.init = function (data) {
        if (data) {
            this.version = data.version;
            this.releaseDate = data.releaseDate ? new Date(data.releaseDate.toString()) : undefined;
            if (data.features) {
                this.features = {};
                for (var key in data.features) {
                    if (data.features.hasOwnProperty(key)) {
                        this.features[key] = data.features[key];
                    }
                }
            }
        }
    };
    ApplicationInfoDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data.version = this.version;
        data.releaseDate = this.releaseDate ? this.releaseDate.toISOString() : undefined;
        if (this.features) {
            data.features = {};
            for (var key in this.features) {
                if (this.features.hasOwnProperty(key)) {
                    data.features[key] = this.features[key];
                }
            }
        }
        return data;
    };
    ApplicationInfoDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new ApplicationInfoDto();
        result.init(json);
        return result;
    };
    return ApplicationInfoDto;
}());
export { ApplicationInfoDto };
